import React, { useContext, useEffect, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { LocaleContext } from 'routes/Router';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import requestCheck from 'assets/images/Dashboard/chevron-right-request.svg';
import ArrowDetail from 'assets/images/Dashboard/arrow-left-request-detail.svg';
import MobileIcon from 'assets/images/Dashboard/call-request-detail.svg';
import MailIcon from 'assets/images/Dashboard/mail-request-detail.svg';
import ImageNull from 'assets/images/Dashboard/image-null.svg';
import { ClearTokenRedirectLogin } from 'utils/general';
import Shimmer from 'components/commom/Shimmer';
import CommonToast from 'components/commom/CommonToast';
import SkinAnalyserImg from 'assets/images/Enterprise/Skin Analyser.png';
import SkinConcernImg from 'assets/images/Enterprise/Skin Concern Identifier.png';
import HairAnalyserImg from 'assets/images/Enterprise/Hair Analyser.png';
import AddIcon from 'assets/images/Dashboard/add-dashboard.svg';
import Loader from 'components/commom/Loader';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import RefreshIcon from '@mui/icons-material/Refresh';
import CreateStaff from './CreateStaff';
import { staffDetail } from 'routes/AppUrls';
import { getParticularEnterpriseCallAPI } from 'store/Enterprise/enterprise/getParticularEnterprise/action';
import { CircularProgress, Tooltip } from '@mui/material';
import { getMasterData } from 'store/masterData/masterDataAction';
import { getLocationCallAPI } from 'store/Enterprise/enterprise/getLocation/action';
import { resendInviteCallAPI } from 'store/Enterprise/staff/resendInvite/action';
import {
  basicDetailsValue,
  PARTICULAR_STAFF,
} from 'store/BasicDetailaAllValue/BasicDetailsValueAction';

const EnterpriseDetail = () => {
  const { locale } = useContext(LocaleContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const particularEnterprise = useSelector(
    (state) => state?.basicDetailsValueReducer?.particularEnterprise
  );
  const enterpriseData = useSelector(
    (state) => state?.getParticularEnterpriseReducer?.users?.data
  );
  const enterpriseLoader = useSelector(
    (state) => state?.getParticularEnterpriseReducer?.loading
  );
  const genderLoader = useSelector(
    (state) => state?.getMasterDataReducer?.loading
  );
  const locationLoader = useSelector(
    (state) => state?.getLocationReducer?.loading
  );
  const resendLoader = useSelector(
    (state) => state?.resendInviteReducer?.loading
  );

  useEffect(() => {
    if (particularEnterprise?.id) {
      getParticularEnterpriseData();
      getGenderData();
      getLocationData();
    }
  }, [particularEnterprise]);

  const getParticularEnterpriseData = () => {
    dispatch(
      getParticularEnterpriseCallAPI(particularEnterprise?.id, {
        run: true,
        handleFunction: () => {},
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      })
    );
  };

  const getGenderData = () => {
    dispatch(
      getMasterData(
        {
          run: true,
          handleFunction: (res) => {},
          error: true,
          handleErrorFunction: (res) => {},
        },
        'gender'
      )
    );
  };

  const getLocationData = () => {
    dispatch(
      getLocationCallAPI(particularEnterprise?.id, {
        run: true,
        handleFunction: (res) => {},
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      })
    );
  };

  const analysisData = [
    { id: 1, name: 'Skin Analysis', img: SkinAnalyserImg },
    { id: 2, name: 'SkinConcern Identifier', img: SkinConcernImg },
    { id: 3, name: 'Hair Analysis', img: HairAnalyserImg },
  ];

  const handleDrawerClose = () => {
    setDrawerOpen(false);
    getParticularEnterpriseData();
  };

  const handleResend = (data) => {
    const body = {
      id: data?.id,
      detail: {},
    };
    dispatch(
      resendInviteCallAPI(body, {
        run: true,
        handleFunction: (res) => {
          showToast(res?.message, 'success');
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      })
    );
  };

  const handleStaffDetail = (data) => {
    dispatch(basicDetailsValue(PARTICULAR_STAFF, data));
    navigate(staffDetail(locale));
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainerrequest lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainerrequest lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <div className="flex pb-16">
            <div className="fs-12 lh-24 family_outfit_regular_400">
              Enterprise
            </div>
            <div className="pl-04 flex items-center">
              <Image src={requestCheck} alt="icon" />
            </div>
            <div className="pl-04 fs-12 fc-242E39 lh-24 family_outfit_semiBold_600">
              Enterprise Details
            </div>
          </div>
          <Row className="bg-light-100 m-0 p-24">
            <Col sm={12} className="p-0">
              <div className="flex">
                <div>
                  <Image
                    src={ArrowDetail}
                    alt="icon"
                    onClick={() => navigate(-1)}
                    className="cursor-pointer"
                  />
                </div>
                <div className="fs-20 lh-252 family_outfit_semiBold_600 fc-292D32 pl-12">
                  Enterprise Details
                </div>
              </div>
              <Row className="m-0 p-0 d-flex align-items-center">
                <Col md={4} className="p-0">
                  <div className="flex align-items-center pt-16">
                    <div className="uploadPhoto">
                      {enterpriseLoader || genderLoader || locationLoader ? (
                        <Shimmer
                          width="100px"
                          height="100px"
                          borderRadius="50%"
                        />
                      ) : (
                        <Image
                          src={ImageNull}
                          alt="Uploaded profile"
                          className={false ? 'uploadPhoto' : ''}
                        />
                      )}
                    </div>
                    <div className="pl-12">
                      {enterpriseLoader || genderLoader || locationLoader ? (
                        <Shimmer width="250px" height="20px" />
                      ) : (
                        <p className="p-0 m-0 fs-20 family_outfit_medium_500 lh-252 fc-202224">
                          {enterpriseData?.name}
                        </p>
                      )}
                      {enterpriseLoader || genderLoader || locationLoader ? (
                        <Shimmer
                          width="250px"
                          height="20px"
                          marginTop={'12px'}
                        />
                      ) : (
                        <p className="pt-12 m-0 fs-14 family_outfit_regular_400 lh-176 fc-A4AAB2">
                          ID:
                          <span className="fs-14 family_outfit_medium_500 lh-176 fc-202224 ml-[8px]">
                            {enterpriseData?.id}
                          </span>
                        </p>
                      )}
                    </div>
                  </div>
                </Col>
                <Col md={8} className="p-0">
                  <Row className="p-0 m-0">
                    <Col md={5} className="p-0 m-0">
                      <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 pt-16">
                        Admin Name
                      </div>
                      {enterpriseLoader || genderLoader || locationLoader ? (
                        <Shimmer
                          width="250px"
                          height="20px"
                          marginTop={'8px'}
                        />
                      ) : (
                        <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                          {enterpriseData?.admin_details?.full_name}
                        </div>
                      )}
                    </Col>
                    <Col md={7} className="p-0 m-0">
                      <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 pt-16">
                        Contact Info
                      </div>
                      <Stack
                        direction="horizontal"
                        gap={5}
                        className="items-center p-0"
                      >
                        {enterpriseLoader || genderLoader || locationLoader ? (
                          <Shimmer
                            width="150px"
                            height="20px"
                            marginTop={'8px'}
                          />
                        ) : (
                          <div className="flex pt-8">
                            <div>
                              <Image src={MobileIcon} alt="icon" />
                            </div>
                            <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pl-12">
                              {enterpriseData?.country_code}
                              {enterpriseData?.contact_number}
                            </div>
                          </div>
                        )}
                        {enterpriseLoader || genderLoader || locationLoader ? (
                          <Shimmer
                            width="150px"
                            height="20px"
                            marginTop={'8px'}
                          />
                        ) : (
                          <div className="flex pt-8">
                            <div>
                              <Image src={MailIcon} alt="icon" />
                            </div>
                            <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pl-12 break-all ...">
                              {enterpriseData?.email}
                            </div>
                          </div>
                        )}
                      </Stack>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
          <div className="my-[16px]">
            <div className="flex flex-wrap gap-[12px]">
              {enterpriseLoader || genderLoader || locationLoader
                ? [1, 2, 3].map((item) => (
                    <Shimmer width="250px" height="50px" />
                  ))
                : analysisData?.map((item, index) => (
                    <div
                      key={index}
                      className="bg-[#FAF1EC] rounded-[4px] px-[10px] py-[15px] w-full max-w-[250px]"
                    >
                      <div className="flex items-center gap-[4px]">
                        <Image src={item?.img} alt="icon" />
                        <div className="text-[16px] text-[#998A7B] family_outfit_regular_400 lh-176">
                          {item?.name}:
                        </div>
                        <div className="text-[16px] text-[#292D32] family_outfit_medium_500 lh-176">
                          {item?.id === 1
                            ? enterpriseData?.skin_analyser_count
                            : item?.id === 2
                              ? enterpriseData?.skin_concern_identifier_count
                              : item?.id === 3
                                ? enterpriseData?.hair_analyser_count
                                : ''}
                        </div>
                      </div>
                    </div>
                  ))}
            </div>
          </div>
          <div className="bg-white p-[24px]">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-[20px]">
              {enterpriseLoader || genderLoader || locationLoader ? (
                <Shimmer width="200px" height="20px" />
              ) : (
                <div className="text-[18px] text-[#292D32] family_outfit_medium_500 lh-176">
                  Staff Members
                </div>
              )}
              {enterpriseLoader || genderLoader || locationLoader ? (
                <Shimmer width="250px" height="40px" />
              ) : (
                <div
                  className="w-full sm:max-w-[30%] md:max-w-[25%] lg:max-w-[15%] fs-16 family_outfit_medium_500 lh-16 pl-04 bg-[#874529] h-[44px] flex items-center justify-center text-white cursor-pointer gap-[10px]"
                  onClick={() => {
                    setDrawerOpen(true);
                  }}
                >
                  <Image src={AddIcon} alt={'icon'} />
                  <div>Add New</div>
                </div>
              )}
            </div>
            <div className="mt-[24px]">
              {enterpriseLoader || genderLoader || locationLoader ? (
                <Loader marginTop={'10vh'} />
              ) : (
                <div className="mt-[30px]">
                  <Row className="listCustomHeader m-0 p-0 flex items-center">
                    <Col lg={2} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        Name
                      </p>
                    </Col>
                    <Col lg={2} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        Contact Info
                      </p>
                    </Col>
                    <Col lg={1} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        Gender
                      </p>
                    </Col>
                    <Col lg={2} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        Skin Analyser
                      </p>
                    </Col>
                    <Col lg={2} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        Skin Concern Identifier
                      </p>
                    </Col>
                    <Col lg={2} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        Hair Analyser
                      </p>
                    </Col>
                    <Col lg={1} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        Invite
                      </p>
                    </Col>
                  </Row>
                  <Row className="bc-FFFFFF m-0 p-0">
                    {enterpriseData &&
                    enterpriseData?.staff_members?.length > 0 ? (
                      enterpriseData?.staff_members?.map((item, index) => (
                        <Row
                          className="m-0 p-0 flex items-center listAppointment"
                          key={index}
                        >
                          <Col
                            lg={2}
                            md={6}
                            sm={12}
                            style={{
                              borderLeft: !item?.is_invite_accepted
                                ? '4px solid #F59E0B'
                                : '4px solid #059F3E',
                              cursor: 'pointer',
                              minHeight: '45px',
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                            }}
                            onClick={() => {
                              handleStaffDetail(item);
                            }}
                          >
                            <div className="fs-14 fc-202224 family_outfit_medium_500 lh-176 flex items-center break-all">
                              {item?.name}
                            </div>
                            <div className="pt-04 fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center break-all">
                              {item?.location
                                ? item?.location?.location_id
                                : ''}
                            </div>
                          </Col>
                          <Col lg={2} md={6} sm={12}>
                            <div className="flex items-center gap-[10px]">
                              {item?.email && (
                                <Tooltip title={item?.email} arrow>
                                  <Image
                                    src={MailIcon}
                                    alt="icon"
                                    style={{ cursor: 'pointer' }}
                                  />
                                </Tooltip>
                              )}
                              {item?.contact_number && (
                                <Tooltip title={item?.contact_number} arrow>
                                  <Image
                                    src={MobileIcon}
                                    alt="icon"
                                    style={{ cursor: 'pointer' }}
                                  />
                                </Tooltip>
                              )}
                            </div>
                          </Col>
                          <Col lg={1} md={6} sm={12}>
                            <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                              {item?.gender}
                            </div>
                          </Col>
                          <Col lg={2} md={6} sm={12}>
                            <div className="fs-14 text-[#4497EA] family_outfit_regular_400 lh-176 underline">
                              {`${item?.skin_analyser_count}`}
                            </div>
                          </Col>
                          <Col lg={2} md={6} sm={12}>
                            <div className="fs-14 text-[#4497EA] family_outfit_regular_400 lh-176 underline">
                              {`${item?.skin_concern_identifier_count}`}
                            </div>
                          </Col>
                          <Col lg={2} md={6} sm={12}>
                            <div className="fs-14 text-[#4497EA] family_outfit_regular_400 lh-176 underline">
                              {`${item?.hair_analyser_count}`}
                            </div>
                          </Col>
                          <Col lg={1} md={6} sm={12}>
                            {!item?.is_invite_accepted ? (
                              <div
                                className="fs-14 fc-202224 family_outfit_regular_400 lh-176 cursor-pointer"
                                onClick={() => {
                                  !resendLoader && handleResend(item);
                                }}
                              >
                                {resendLoader ? (
                                  <CircularProgress size={24} color="inherit" />
                                ) : (
                                  <RefreshIcon sx={{ color: '#375241' }} />
                                )}
                              </div>
                            ) : null}
                          </Col>
                        </Row>
                      ))
                    ) : (
                      <div className="flex justify-center pt-120">
                        <Image src={EmptyScreen} alt="icon" />
                        <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center	pt-30">
                          Nothing here yet
                        </div>
                      </div>
                    )}
                  </Row>
                </div>
              )}
            </div>
          </div>
          <div className="mt-[20px] flex items-center justify-end gap-[24px]">
            <div className="flex items-center gap-[8px]">
              <div className="h-[18px] w-[18px] bg-[#F59E0B]"></div>
              <div className="text-[14px] text-[#202224] lh-2 family_outfit_regular_400">
                Invited
              </div>
            </div>
            <div className="flex items-center gap-[8px]">
              <div className="h-[18px] w-[18px] bg-[#059F3E]"></div>
              <div className="text-[14px] text-[#202224] lh-2 family_outfit_regular_400">
                Onboarded
              </div>
            </div>
          </div>
          <CreateStaff open={drawerOpen} onClose={handleDrawerClose} />
        </Col>
      </Row>
    </div>
  );
};

export default EnterpriseDetail;
